import { AssignedModalCostCenterProps, EmployeeNodeModel } from '../../models';

export const ASSIGNED_MODAL_COST_CENTER_PROPS_EMPTY: AssignedModalCostCenterProps = {
    startDate: '',
    endDate: '',
    employee: {} as EmployeeNodeModel[],
    parentNodeSelected: {} as number[],
};
